import { useAuthContext } from "@hooks/context/useAuthContext";
import { PageLoader } from "@stories/atoms/Loaders/PageLoader/PageLoader";
import { useEffect } from "react";
import { useLocation, useNavigate } from "react-router-dom";
import * as RouteHelper from "@utils/routes";

export const Verify = () => {
  const { answerCustomChallenge, isFirstLoad } = useAuthContext();
  const location = useLocation();
  const navigate = useNavigate();

  useEffect(() => {
    console.log("VERIFYING....");
    if (!isFirstLoad) {
      const params = new URLSearchParams(location.search);
      const [email, answer] = [
        params.get("email") || "",
        params.get("code") || "",
      ];

      answerCustomChallenge(email, answer)
        .then((res) => {
          if (!res) {
            navigate(RouteHelper.home);
          }
        })
        .catch((e) => {
          console.log(e);
          alert("Invalid login link!");
          navigate(RouteHelper.home);
        });
    }
  }, [isFirstLoad]);
  return (
    <>
      <PageLoader />
    </>
  );
};
